import { UploadWarrantController } from './uploadWarrant.controller';
import template from './uploadWarrant.html';

export const uploadWarrantComponent = {
  name: 'uploadWarrantComponent',
  restrict: 'E',
  template,
  controller: UploadWarrantController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<'
  }
};
